import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

/** The tracker and the exposed accounts list, each with its overview page as a hidden child for the breadcrumb. */
export const annotationNotesNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.annotation_notes_tracker, {
      displayName: 'Tracker',
      icon: SolIcon.asm_tracker,
      showChildrenInNavbar: false,
      children: [
        SolNavbarItem.of(PrototypeRouteId.annotation_notes_tracker_overview, {
          displayName: 'asm-prototype.annotation-notes.finding.name',
          nameParams: ['findingName'],
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.annotation_notes_exposed_accounts, {
      displayName: 'Exposed accounts',
      icon: SolIcon.asm_credentials,
      showChildrenInNavbar: false,
      children: [
        SolNavbarItem.of(PrototypeRouteId.annotation_notes_exposed_account_overview, {
          displayName: 'asm-prototype.annotation-notes.account.name',
          nameParams: ['accountName'],
        }),
      ],
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
